import { gql } from "@apollo/client";

export const SETTINGS = gql`
    query settings {
        settings {
            MISSION_END_DATE
            MISSION_START_DATE
            MISSION_ID
            MISSION_NAME
        }
    }
`;

export default SETTINGS;
